module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-rain-fill-839d4f5e.svg";